import React, { useContext, useState } from "react";
import axios from "axios";

import { StepperContext } from "../../Contexts/Stepper";
import { LanguageContext } from "../../Contexts/Language";
import messages from "../../utils/messages";
import { UserPhoneContext } from "../../Contexts/UserPhone";
import { NUMBERS_REGEX } from "../../utils/constants";

export const Step3 = () => {
  const { lang } = useContext(LanguageContext);
  const { userPhone } = useContext(UserPhoneContext);
  const {
    enterVerificationCode,
    verificationCodeRequired,
    verificationCodeInvalid,
    confirm,
  } = messages[lang];

  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [validCode, setValidCode] = useState(true);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [serverErr, setServerErr] = useState("");

  const { step, setStep } = useContext(StepperContext);

  const handleSubmit = async (e) => {
    try {
      // validations
      e.preventDefault();
      if (!validateVerificationCode(code)) {
        setValidCode(false);
        return;
      }

      setLoading(true);

      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/users/confirm_delete_account`,
        {
          data: { phone_number: userPhone, delete_account_code: code },
          headers: {
            "Accept-Language": lang,
          },
        }
      );

      setLoading(false);
      setStep(step + 1);
    } catch (error) {
      setLoading(false);
      setServerErr(error?.response?.data?.message);
    }
  };

  const validateVerificationCode = (codeNumber) => {
    return NUMBERS_REGEX.test(codeNumber);
  };

  const handleCodeChange = (e) => {
    setServerErr("");
    setCode(e.target.value);
    setIsBtnDisabled(!validateVerificationCode(e.target.value));
    setValidCode(validateVerificationCode(e.target.value));
  };

  return (
    <div>
      <p>{enterVerificationCode}</p>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {loading ? (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} autoComplete="off">
            <input
              type="text"
              id="code"
              value={code}
              className="code-input"
              onChange={handleCodeChange}
              style={{
                fontSize: "16px",
                verticalAlign: "centre",
                direction: "ltr",
              }}
              required
            />
            <p
              className="error"
              style={{
                visibility: !validCode || !!serverErr ? "visible" : "hidden",
              }}>
              {serverErr
                ? serverErr
                : code === ""
                ? verificationCodeRequired
                : verificationCodeInvalid}
            </p>
            <button
              className={isBtnDisabled || !!serverErr ? "disabled" : ""}
              type="submit"
              disabled={isBtnDisabled || !!serverErr}>
              {confirm}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
